import { Github } from 'styled-icons/boxicons-logos/Github'
import { Instagram } from 'styled-icons/boxicons-logos/Instagram'
import { Linkedin } from 'styled-icons/boxicons-logos/Linkedin'

const Icons = {
  Github,
  Instagram,
  Linkedin
}

export default Icons